import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const unStoreApprovalStatusesAdapter = getAdapter({ idFieldName: 'value' });

const unStoreApprovalStatusesSlice = createSlice({
  name: 'unStoreApprovalStatuses',
  initialState: unStoreApprovalStatusesAdapter.getInitialState(),
  reducers: {
    setUnStoreApprovalStatuses: (state, { payload: { unStoreApprovalStatuses } }) => {
      unStoreApprovalStatusesAdapter.setAll(state, unStoreApprovalStatuses);
    },
  },
});

const selectors = unStoreApprovalStatusesAdapter.getSelectors(({ unStoreApprovalStatuses }) => unStoreApprovalStatuses);

export const getUnStoreApprovalStatuses = (state) => selectors.selectAll(state);

export const {
  setUnStoreApprovalStatuses,
} = unStoreApprovalStatusesSlice.actions;

export default unStoreApprovalStatusesSlice.reducer;
